module.exports = __webpack_public_path__ + "static/media/bitvoUppLogin.4e4ef5a8.png";